import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import PreviewImages, {
  PreviewImagesRef,
} from "../../../components/PreviewImages";
import styles from "./index.module.scss";

export default () => {
  const location: any = useLocation();
  const imgList = (location.state && location.state.imgList) || [];
  const title = (location.state && location.state.title) || "服务详情";
  const previewRef = useRef<PreviewImagesRef>(null);

  document.title = title;

  if (Array.isArray(imgList) && imgList.length > 0) {
    return (
      <div className={styles.pagePreviewWrapper}>
        {imgList?.map((imgSrc, index) => (
          <div
            className={styles.imgCotainer}
            onClick={() => previewRef.current?.open({ index, urls: imgList })}
            key={index}
          >
            <img src={imgSrc} alt="" />
          </div>
        ))}
        <PreviewImages ref={previewRef} />
      </div>
    );
  } else {
    return <div>无照片</div>;
  }
};
